<script setup>
import { computed } from 'vue'
import { formatSportTitle } from '@/services/utils.js'
import BetStatus from '../BetStatus.vue'

const props = defineProps({
  combo: {
    type: Array,
    default: () => []
  },
  canEdit: {
    type: Boolean,
    default: true
  },
  invalid_outcome_ids: {
    type: Array,
    default: () => []
  }
})

// computed che ordina combo per event.commence_time
// Gestisce casi in cui `event` o `event.commence_time` non siano presenti.
const sortedCombo = computed(() => {
  // Copia l'array per non mutare le props
  const copy = Array.isArray(props.combo) ? [...props.combo] : []

  // Separiamo gli item con commence_time valido da quelli senza
  const withTime = copy.filter(item => item && item.event && item.event.commence_time)
  const withoutTime = copy.filter(item => !(item && item.event && item.event.commence_time))

  // Ordiniamo solo quelli che hanno commence_time
  withTime.sort((a, b) => new Date(a.event.commence_time) - new Date(b.event.commence_time))

  // Ritorniamo prima quelli ordinati, poi i fallback senza data
  return [...withTime, ...withoutTime]
})
</script>

<template>
  <v-row dense>
    <v-col
      v-for="(item, index) in sortedCombo"
      :key="index"
      cols="12"
      sm="6"
      md="4"
    >
      <v-card class="combo-card" elevation="2"
        v-bind="(!canEdit && item && item.event) ? { tag: 'a', to: { name: 'event', params: { id: item.event.id } } } : {}"
      >
        <template v-if="item && item.event">
          <v-card-text :class="invalid_outcome_ids.includes(item.outcome.id) ? 'text-error' : null">
            <div class="sport-title">{{ formatSportTitle(item.event.sport_key) }}</div>
            <div class="match-title my-2">{{ item.event.home_team }} <span class="vs">vs</span> {{ item.event.away_team }}</div>
            <div class="sport-title my-2">
              <v-icon size="small" class="me-1">mdi-calendar</v-icon>
              {{ $d(item.event.commence_time, 'long') }}
            </div>
            <v-divider class="my-4"></v-divider>
            <div class="my-2">
              <span class="outcome-name">{{ $t(`events.betting.betTypes.${item.outcome.market_key}`) }}</span>:
              {{ item.outcome.name }}
            </div>
            <div><span class="text-success">{{ item.outcome.price }}</span></div>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <div class="sport-title">{{ $t('events.unavailable') || 'Event unavailable' }}</div>
            <div class="my-2">{{ item && item.outcome ? item.outcome.name : '' }}</div>
            <div><span class="text-success">{{ item && item.outcome ? item.outcome.price : '' }}</span></div>
          </v-card-text>
        </template>
        <v-card-actions>
          <v-btn v-if="canEdit"
            :variant="invalid_outcome_ids.includes(item.outcome.id) ? 'tonal' : 'text'"
            size="small"
            :color="invalid_outcome_ids.includes(item.outcome.id) ? 'error' : 'amber-darken-2'"
            @click="$emit('remove', index)">{{ $t('common.remove') }}</v-btn>

           <BetStatus v-if="!canEdit" :status="item.status" />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.combo-card {
  border-radius: 10px;
}
.vs {
  margin: 0 6px;
  color: #9e9e9e;
}
.outcome-name, .sport-title {
  color: #b0bec5;
}
</style>
